import Vue from 'vue'
import Router from 'vue-router'
// 首页
import Index from '../pages/Home.vue'
// 最新更新
import LatestUpdates from '../pages/LatestUpdates/LatestUpdates.vue'
// 隧说网事
import TunnelOnline from '../pages/LatestUpdates/tunnelOnline.vue'
// 详情
import BookDetail from '../pages/BookDetails/BookDetail.vue'
// 目录
import BookCatalog from '../pages/BookDetails/BookCatalog.vue'
// 评论
import BookComment from '../pages/BookDetails/BookComment.vue'
// 试读
import BookTryRead from '../pages/BookDetails/BookTryRead.vue'
// 阅读
import BookRead from '../pages/BookDetails/BookRead.vue'
// 付款界面
import BookPayment from '../pages/BookDetails/BookPayment.vue'
// 支付成功
import PaySuccess from '../pages/Payment/PaySuccess.vue'
// 支付失败
import PayError from '../pages/Payment/PayError.vue'
// 我的书单
import MyBookList from '../pages/MemberCenter/MyBookList.vue'
// 订单详情
import OrderInfo from '../pages/MemberCenter/OrderInfo.vue'
// 购物车
import MyCart from '../pages/MyCart/MyCart.vue'
// 购物车详情
import ConfirmOrder from '../pages/MyCart/ConfirmOrder.vue'
// 我的订单
import MyOrderList from '../pages/MemberCenter/MyOrderList.vue'
// 深邃合集
import DeepCompDetail from '../pages/DeepCompilations/DeepCompDetail.vue'
// 在线留言
import OnlineMessage from '../pages/OnlineMessage/OnlineMessage.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			redirect: 'Index',
			meta: {
				title: '知识服务'
			}
		},
		{
			path: '/index',
			name: 'Index',
			component: Index,
			meta: {
				title: '知识服务'
			}
		},
		{
			path: '/latestUpdates',
			name: 'LatestUpdates',
			component: LatestUpdates,
			meta: {
				title: '最新更新'
			}
		},
		{
			path: '/tunnelOnline',
			name: 'TunnelOnline',
			component: TunnelOnline,
			meta: {
				title: '隧说网事'
			}
		},
		{
			path: '/bookDetail',
			name: 'BookDetail',
			component: BookDetail,
			children: [
				{
					path: 'bookCatalog',
					name: 'BookCatalog',
					component: BookCatalog,
					meta: {
						title: '目录'
					}
				}
			],
			redirect: '/bookDetail/bookCatalog'
		},
		{
			path: '/bookComment',
			name: 'BookComment',
			component: BookComment,
			meta: {
				title: '评论'
			}
		},
		{
			path: '/bookTryRead',
			name: 'BookTryRead',
			component: BookTryRead,
			meta: {
				title: '试读'
			}
		},
		{
			path: '/bookRead',
			name: 'BookRead',
			component: BookRead,
			meta: {
				title: '阅读'
			}
		},
		{
			path: '/bookPayment',
			name: 'BookPayment',
			component: BookPayment,
			meta: {
				title: '付款'
			}
		},
		{
			path: '/paySuccess',
			name: 'PaySuccess',
			component: PaySuccess,
			meta: {
				title: '支付成功'
			}
		},
		{
			path: '/payError',
			name: 'PayError',
			component: PayError,
			meta: {
				title: '支付失败'
			}
		},
		{
			path: '/myBookList',
			name: 'MyBookList',
			component: MyBookList,
			meta: {
				title: '我的书单'
			}
		},
		{
			path: '/orderInfo',
			name: 'OrderInfo',
			component: OrderInfo,
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/myCart',
			name: 'MyCart',
			component: MyCart,
			meta: {
				title: '购物车'
			}
		},
		{
			path: '/confirmOrder',
			name: 'ConfirmOrder',
			component: ConfirmOrder,
			meta: {
				title: '确认订单'
			}
		},
		{
			path: '/myOrderList',
			name: 'MyOrderList',
			component: MyOrderList,
			meta: {
				title: '我的订单'
			}
		},
		{
			path: '/deepCompDetail',
			name: 'DeepCompDetail',
			component: DeepCompDetail,
			meta: {
				title: '深邃合集'
			}
		},
		{
			path: '/message',
			name: 'Message',
			component: OnlineMessage,
			meta: {
				title: '在线留言'
			}
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js